import { actions } from '.';

export function selectTeamId(payload) {
  return {
    type: actions.SELECT_TEAM_ID,
    payload
  };
}

export function DateSelectionChanged(payload) {
  return {
    type: actions.DATE_SELECTION_CHANGED,
    payload
  };
}

export function routeChanged(payload) {
  return {
    type: actions.ROUTE_CHANGED,
    payload
  };
}

export function toggleSnackBar(payload) {
  return {
    type: actions.TOGGLE_SNACKBAR,
    payload
  };
}

export function setDefaultBoardSucceed(payload) {
  return {
    type: actions.SET_DEFAULT_BOARD_SUCCEED,
    payload
  };
}

export function setDefaultBoardFailure(payload) {
  return {
    type: actions.SET_DEFAULT_BOARD_FAILURE,
    payload
  };
}

export const selectIterationId = payload => ({
  type: actions.SELECT_ITERATION_ID,
  payload
});

export const selectPeriodKey = payload => ({
  type: actions.SELECT_PERIOD_KEY,
  payload
});

export const setIsProcessingRepos = payload => ({
  type: actions.SET_IS_PROCESSING_REPOS,
  payload
});

export const setHasNoData = payload => ({
  type: actions.SET_HAS_NO_DATA,
  payload
});

export const setIsBlurred = payload => ({
  type: actions.SET_IS_BLURRED,
  payload
});

export const setHasIterations = payload => ({
  type: actions.SET_HAS_ITERATIONS,
  payload
});

export const setSelectedTeamChangedFromTopBar = payload => ({
  type: actions.SET_SELECTED_TEAM_CHANGED_FROM_TOPBAR,
  payload
});
